import moment from "moment";

/**
 * Generates CSS class based on destination status
 * @param {*} status destination status
 * @returns {string} CSS class
 */
export function generateStatusClass(status) {
    if (status === "ACTIVE") {
        return "badge-success";
    } else if (status === "INACTIVE") {
        return "badge-danger";
    }
}

/**
 * Generates CSS class based on visibility status
 * @param {*} visibilityStatus visibility status
 * @returns {string} CSS class
 */
export function generateVisibilityStatusClass(visibilityStatus) {
    if (visibilityStatus === "PUBLISHED") {
        return "status-confirmed";
    } else if (visibilityStatus === "PENDING") {
        return "status-started";
    }
}

/**
 * Formats the destination status for display
 * @param {*} status destination status
 * @returns {string} formatted status
 */
export function formatDestinationStatus(status) {
    if (status === "ACTIVE") {
        return "Active";
    } else if (status === "INACTIVE") {
        return "Inactive";
    }
}

/**
 * Formats the visibility status for display
 * @param {*} visibilityStatus visibility status
 * @returns {string} formatted visibility status
 */
export function formatVisibilityStatus(visibilityStatus) {
    if (visibilityStatus === "PUBLISHED") {
        return "Published";
    } else if (visibilityStatus === "PENDING") {
        return "Pending Publication";
    }
}

/**
 * Formats the last updated date
 * @param {Date|string} date last updated date
 * @returns {string} formatted date
 */

export function formatLastUpdatedAt(date) {
    if (!date) return "Not Available";
    return moment(date).format("DD MMM. YYYY - hh:mm A");
}

/**
 * Formats the destination name based on its type
 * @param {string} destinationType type of the destination ("CITY" or "COUNTRY")
 * @param {object} destination destination object
 * @returns {string} formatted destination name
 */
export function formatDestinationName(destinationType, destination) {
    if (!destination) return "Unknown Destination";
    if (destinationType === "CITY") {
        return destination.city || "Unnamed City";
    } else if (destinationType === "COUNTRY") {
        let country = destination.country || {};
        if (country.name) {
            return country.name;
        }
        return destination.name || "Unnamed Country";
    }
}

/**
 * Formats the destination type label for display
 * @param {string} destinationType type of the destination ("CITY" or "COUNTRY")
 * @returns {string} formatted destination type label
 */
export function formatDestinationTypeLabel(destinationType) {
    if (destinationType === "CITY") {
        return "Destination City";
    } else if (destinationType === "COUNTRY") {
        return "Destination Country";
    }
}